import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { ApiHelper } from "../../../helpers/apihelper";
import { AuthService } from "../../../services/authservice";

interface NotificationDialogData {
  name: string;
  subscriptionId: string;
  impactSetting?: string;
}

@Component({
  selector: "dialog-notification-settings",
  templateUrl: "dialog-notification-settings.html",
  styleUrl: "dialog-notification-settings.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe, FormsModule],
})
export class DialogNotificationSettings {
  private readonly api = inject(ApiHelper);
  private readonly dialogRef = inject(MatDialogRef);
  protected readonly auth = inject(AuthService);

  private data = inject<NotificationDialogData>(MAT_DIALOG_DATA);
  protected name = computed(() => this.data.name);
  protected subscriptionId = computed(() => this.data.subscriptionId);

  protected notificationSetting = signal(this.data.impactSetting ?? "Loss of Resiliency");

  protected closeDialog() {
    this.dialogRef.close();
  }

  protected saveSettings() {
    const customerGuid = this.auth.viewingCustomer().customerId;
    this.api
      .set_minimal_impact_notification(customerGuid, this.subscriptionId(), this.notificationSetting())
      .then(() => {
        this.dialogRef.close({ refresh: true, minimalImpactNotification: this.notificationSetting() });
      })
      .catch((err) => {
        console.log(err);
      });
  }
}
